import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
export const useGuestAlbums = () => {
  const [albums, setAlbums] = useState(cache || []);
  useEffect(() => { api.get("/admin/guest-albums").then((r) => { cache = r.data.albums; setAlbums(cache); }); }, []);
  return albums;
};

export const GuestAlbumPicker = ({ mode, ids, onChange, testid = "guest-albums" }) => {
  const albums = useGuestAlbums();
  const toggle = (id) => onChange(mode, ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id]);
  return (
    <fieldset className="text-xs text-neutral-600 w-full" data-testid={testid}>
      <legend className="mb-1">Albums this guest can see</legend>
      <label className="mr-4 inline-flex items-center gap-1"><input type="radio" checked={mode === "all"} onChange={() => onChange("all", ids)} data-testid={`${testid}-mode-all`} /> All Guest albums</label>
      <label className="inline-flex items-center gap-1"><input type="radio" checked={mode === "selected"} onChange={() => onChange("selected", ids)} data-testid={`${testid}-mode-selected`} /> Only selected albums</label>
      {mode === "selected" && (
        <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 max-h-40 overflow-auto" data-testid={`${testid}-checklist`}>
          {albums.length === 0 && <span className="text-neutral-400">No albums in the Guest space yet.</span>}
          {albums.map((a) => (
            <label key={a.id} className="inline-flex items-center gap-1 text-neutral-800">
              <input type="checkbox" checked={ids.includes(a.id)} onChange={() => toggle(a.id)} data-testid={`${testid}-album-${a.id}`} />
              {a.name}{a.yearbook ? " (Year Book)" : a.smart ? " (smart)" : ""}
            </label>
          ))}
        </div>
      )}
    </fieldset>
  );
};

export const AlbumChips = ({ link }) => {
  const albums = useGuestAlbums();
  if (link.album_mode !== "selected") return <span className="text-xs text-neutral-500" data-testid={`guest-albums-chip-${link.id}`}>All Guest albums</span>;
  const names = link.album_ids.map((id) => albums.find((a) => a.id === id)?.name).filter(Boolean);
  return (
    <span className="inline-flex flex-wrap gap-1" data-testid={`guest-albums-chip-${link.id}`}>
      <span className="text-xs text-neutral-500">{link.album_ids.length} {link.album_ids.length === 1 ? "album" : "albums"}:</span>
      {names.map((n) => <span key={n} className="role-chip">{n}</span>)}
    </span>
  );
};
